import ClientStatisticsStore from "./ClientStatisticsStore";

// In-memory cache so Statistics selections survive screen unmount/remount.
// Keyed by client.id so revisiting the same client restores selections.
const storeByClientId = new Map();

export const getClientStatisticsStore = (client) => {
  const clientId = client?.id ?? null;
  if (!clientId) {
    // Fallback: ephemeral store (should be rare).
    return new ClientStatisticsStore({ client });
  }

  const existing = storeByClientId.get(clientId);
  if (existing) {
    existing.setClient(client);
    return existing;
  }

  const created = new ClientStatisticsStore({ client });
  storeByClientId.set(clientId, created);
  return created;
};

export const clearClientStatisticsStore = (clientId) => {
  if (!clientId) return;
  storeByClientId.delete(clientId);
};
